<template>
  <div :class="$style.container">
    <header :class="$style.header">
      <JumpcloudBrandmark
        :scale="2"
        type="jcLogoWordmark"
      />
      <ButtonClose @click="handleClose" />
    </header>
    <div>
      <DeviceSetup
        v-if="setupFlow === 'device'"
        :defaultOs="defaultDevice"
        @close="handleClose"
      />
    </div>
  </div>
</template>

<script>
import {
  ButtonClose,
  JumpcloudBrandmark,
} from '@jumpcloud/ui-components';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import DeviceSetup from 'client/Discover/components/GuidedSetup/DeviceSetup.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const {
  description,
  iconName,
  location,
  section,
} = eventProperties;

export default {
  name: 'GuidedSetup',

  components: {
    ButtonClose,
    DeviceSetup,
    JumpcloudBrandmark,
  },

  EventHelper,

  props: {
    defaultDevice: {
      type: String,
      default: '',
    },

    setupFlow: {
      type: String,
      required: true,
    },
  },

  methods: {
    closeGuidedSetup() {
      this.$emit('close');
    },

    handleClose() {
      this.$options.EventHelper.triggerIconClicked({
        [description]: 'Closes the immersive onboarding guided setup',
        [iconName]: 'close',
        [location]: eventLocations.immersiveOnboarding,
        [section]: `${this.setupFlow} setup - header`,
      });

      this.closeGuidedSetup();
    },
  },
};
</script>

<style scoped module>
.container {
  background-color: var(--jc-color-surface-light);
  bottom: 0;
  height: 100%;
  left: 0;
  max-height: 100vh;
  position: fixed;
  right: 0;
  text-align: left;
  width: 100%;
  z-index: 1000;
}

.header {
  border-bottom: 1px solid var(--jc-color-neutral-stroke);
  display: flex;
  justify-content: space-between;
  padding: var(--jc-spacer);
}
</style>
